import React, { useContext, useRef } from "react";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { icons } from "../../../constants";

const Textarea = ({
  placeholder,
  label,
  value,
  handleValueChange,
  email,
  required,
  error,
}) => {
  const handleChange = (event) => {
    handleValueChange(event.target.value);
  };
  const { t, isLoading } = useContext(TranslationsContext);
  const textareaRef = useRef(null);

  const insertText = (wrapper) => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const currentValue = value || ""; // fallback ako je undefined
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selected = currentValue.substring(start, end) || "";

    // Ako je selektovani tekst isti kao wrapper — ne ubacuj ponovo
    if (selected === wrapper) return;

    const newText =
      currentValue.substring(0, start) + wrapper + currentValue.substring(end);

    handleValueChange(newText);

    setTimeout(() => {
      textarea.focus();
      const cursorPos = start + wrapper.length;
      textarea.setSelectionRange(cursorPos, cursorPos);
    }, 0);
  };

  const parsePreviewText = (text) => {
    if (!text) return "";

    // Escape HTML
    let escaped = text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

    // Replace bold: **text**
    escaped = escaped.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    // Replace italic: _text_
    escaped = escaped.replace(/_(.*?)_/g, "<em>$1</em>");

    // Replace newlines with <br>
    escaped = escaped.replace(/\n/g, "<br>");

    return escaped;
  };

  return (
    <div
      className={`flex-direction-column items-center ${
        email ? "gap-14" : "gap-8"
      } width-100 height-100 textarea`}
    >
      {label && (
        <div className="flex-direction-row items-center width-100 relative">
          {required && (
            <img
              src={icons.required}
              alt="req"
              width={12}
              height={12}
              style={{ position: "absolute", top: "0px", left: "0" }}
            />
          )}
          <label className="width-100 font-12 inria-sans-700">{label}</label>
        </div>
      )}
      <div className="flex-direction-column gap-8 width-100">
        {email && (
          <div
            className="flex-direction-row gap-6 width-100"
            style={{ flexWrap: "wrap" }}
          >
            <AccreditationButton
              onClick={() => insertText("[[ime]]")}
              type="placeholder"
              title={t("NAME")}
            />
            <AccreditationButton
              onClick={() => insertText("[[prezime]]")}
              type="placeholder"
              title={t("SURNAME")}
            />
            <AccreditationButton
              onClick={() => insertText("[[link]]")}
              type="placeholder"
              title={t("LINK")}
            />
            <AccreditationButton
              onClick={() => insertText("[[naziv_dogadjaja]]")}
              type="placeholder"
              title={t("EVENT_NAME")}
            />
            <AccreditationButton
              onClick={() => insertText("[[lokacija_dogadjaja]]")}
              type="placeholder"
              title={t("LOCATION")}
            />
            <AccreditationButton
              onClick={() => insertText("[[datum_pocetka]]")}
              type="placeholder"
              title={t("EVENT_START_DATE")}
            />
            <AccreditationButton
              onClick={() => insertText("[[datum_kraja]]")}
              type="placeholder"
              title={t("EVENT_END_DATE")}
            />
            <AccreditationButton
              onClick={() => insertText("[[naziv_grupe]]")}
              type="placeholder"
              title={t("EVENT_GROUP")}
            />
            {/* <AccreditationButton
              onClick={() => insertText("**")}
              type="add-confirm"
              title={t("BOLD")}
            />
            <AccreditationButton
              onClick={() => insertText("_")}
              type="add-confirm"
              title={t("ITALIC")}
            /> */}
          </div>
        )}

        <textarea
          ref={textareaRef}
          className={`inria-sans-300 font-12 ${error ? "invalid" : ""}`}
          placeholder={placeholder}
          value={value || ""}
          onChange={handleChange}
          rows={5}
        />
      </div>
      {/* {email && (
        <div className="flex-direction-column gap-8 width-100">
          <label className="font-12 inria-sans-700">Preview:</label>
          <div
            className="inria-sans-400 font-12 email-preview"
            dangerouslySetInnerHTML={{ __html: parsePreviewText(value || "") }}
          />
        </div>
      )} */}
    </div>
  );
};
export default Textarea;
